<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-22 14:51:30
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-01-10 20:59:22
 * @FilePath: /notion-widgets-site/src/views/Lib.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Layouts>
    <div class="lib-container">
      <el-container>
        <el-header>
          <!-- <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
          >
            <el-menu-item index="/lib/time">🕙 时间组件</el-menu-item>
            <el-menu-item index="2" disabled>效率组件</el-menu-item>
            <el-menu-item index="/lib/others">🔧 其他组件</el-menu-item>
            <el-menu-item index="/lib/formula" disabled
              >🟰 Notion 公式</el-menu-item
            >
          </el-menu> -->
          <el-select
            v-model="active_tab"
            placeholder="请选择"
            @change="handleSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.label"
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
          <br />
          <!-- <el-alert
            title="所有组件和模版都🈲️二改🈲️二传，交作业请标注来源，谢谢！"
            type="error"
            center=""
          >
          </el-alert> -->
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </div>
  </Layouts>
</template>
<script>
import Layouts from "@/components/Layouts-v2.vue";
export default {
  components: { Layouts },
  data() {
    return {
      active_tab: 0,
      options: [
        { label: "🕙 时间组件", to: "/lib/time", id: 0, disabled: false },
        { label: "💪 效率组件", to: "/lib/eff", id: 1, disabled: false },
        { label: "🔧 其他组件", to: "/lib/others", id: 2, disabled: false },
        { label: "🟰 Notion 公式", to: "/lib/formula", id: 3, disabled: true },
      ],
    };
  },
  computed: {
    activeIndex() {
      let name = this.$route.name;
      return `/lib/${name}`;
    },
  },
  mounted() {
    this.$notify({
      title: "⚠️ 注意",
      message: "所有组件和模版都🈲️二改🈲️二传，交作业请标注来源，谢谢！",
      type: "warning",
      duration: 3000,
    });
    let name = this.$route.name;
    let item = this.options.find(option => option.to.includes(name));
    item && (this.active_tab = item.id);
  },
  methods: {
    handleSelect(id) {
      let item = this.options[id];
      this.$router.push(item.to)
    },
  },
};
</script>
<style lang="less" scoped>
@import "../less/var.less";
.lib-container {
  padding: 30px;
  padding-top: 120px;
  min-height: 70vh;
}
</style>
